/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CalculationType = {
    PredefinedMarketRrpAndFixedLpPricePoints: 'PredefinedMarketRrpAndFixedLpPricePoints',
    LpOnly: 'LpOnly',
    DirectCurrencyConversion: 'DirectCurrencyConversion',
    LicensedProducts: 'LicensedProducts',
    TargetDrivenLpAndRrpCalculatedRm: 'TargetDrivenLpAndRrpCalculatedRm'
} as const;
export type CalculationType = typeof CalculationType[keyof typeof CalculationType];


export function instanceOfCalculationType(value: any): boolean {
    for (const key in CalculationType) {
        if (Object.prototype.hasOwnProperty.call(CalculationType, key)) {
            if (CalculationType[key as keyof typeof CalculationType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CalculationTypeFromJSON(json: any): CalculationType {
    return CalculationTypeFromJSONTyped(json, false);
}

export function CalculationTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CalculationType {
    return json as CalculationType;
}

export function CalculationTypeToJSON(value?: CalculationType | null): any {
    return value as any;
}

export function CalculationTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): CalculationType {
    return value as CalculationType;
}

